import { GA_VERSIONS } from "../../constants";

export default class WebsiteAnalytics {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }

  // demographic
  async getGoogleDemographicData(
    subscriberId,
    businessUnitId,
    fromDate,
    toDate
  ) {
    try {
      const Demographic = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/google-analytics/demographic/business/${businessUnitId}/${subscriberId}?toDate=${toDate}&fromDate=${fromDate}`
      );
      return Demographic.data;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  // pages
  async getGooglePageData(subscriberId, businessUnitId, fromDate, toDate) {
    try {
      const Page = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/google-analytics/pages/business/${businessUnitId}/${subscriberId}?toDate=${toDate}&fromDate=${fromDate}`
      );

      return Page.data;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  // trafficsource
  async getTrafficSourceData(subscriberId, businessUnitId, fromDate, toDate) {
    try {
      const TrafficSource = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/google-analytics/trafficsource/business/${businessUnitId}/${subscriberId}?toDate=${toDate}&fromDate=${fromDate}`
      );
      return TrafficSource.data;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  // analyticsurl
  async getAnalyticsUrlData(
    subscriberId,
    businessUnitId /*, fromDate, toDate*/
  ) {
    try {
      const AnalyticsUrl = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/google-analytics/analyticsurl/business/${businessUnitId}/${subscriberId}`
      );
      return AnalyticsUrl.data;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  // visits
  async getVisitsData(subscriberId, businessUnitId, fromDate, toDate) {
    try {
      const Visits = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/google-analytics/visits/business/${businessUnitId}/${subscriberId}?toDate=${toDate}&fromDate=${fromDate}`
      );
      return Visits.data;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  async getAnalyticsData(
    subscriberId,
    businessUnitId,
    fromDate,
    toDate,
    version = GA_VERSIONS.UA
  ) {
    try {
      const Visits = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL_ANALYTIC}/analytics?subscriberId=${subscriberId}&startDate=${fromDate}&endDate=${toDate}&countryId=${businessUnitId}&version=${version}`
      );
      return Visits.data;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }
}
